import { useEffect } from 'react';

interface SchemaOrgProps {
  schemas: object[];
}

export default function SchemaOrg({ schemas }: SchemaOrgProps) {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = schemas.map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((s) => {
        if (document.head.contains(s)) document.head.removeChild(s);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
